import { useMemo } from 'react'
import { Select } from '@/components/select'
import type { MatterSelectDropdownProps } from './types'
import type { MatterRead } from '@/matter/store/schemas'
import { SelectItem } from '../select/types'

/** Adapts matter records to the shared Select component. */

export function MatterSelectDropdown({
  className,
  emptyStateMessage,
  fullWidthContent = false,
  items,
  onCreateNewMatter,
  onSelect,
  placeholder = 'Select Matter',
  selectedItemId,
  size,
  triggerLabel,
  variant = 'inline',
  ...props
}: MatterSelectDropdownProps) {
  // Map the list of matters to a list of select items
  const mapMatterToSelectItem = (matter: MatterRead): SelectItem => {
    return { id: matter.id, label: matter.name }
  }

  const matterItems: SelectItem[] = useMemo(() => {
    return items.map(mapMatterToSelectItem)
  }, [items])

  const handleSelect = (itemId: string) => {
    onSelect(itemId)
  }

  return (
    <Select
      className={className}
      createAction={onCreateNewMatter ? { label: 'New Matter', onClick: onCreateNewMatter } : undefined}
      emptyStateMessage={!items?.length ? emptyStateMessage : undefined}
      fullWidthContent={fullWidthContent}
      items={matterItems}
      onSelect={handleSelect}
      placeholder={placeholder}
      selectedItemId={selectedItemId}
      size={size}
      triggerLabel={triggerLabel}
      variant={variant}
      {...props}
    />
  )
}
